module.exports = __webpack_public_path__ + "static/img/sg_btn2.b213312.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/home/pc/role3/control/sg_btn2.png
// module id = JvYv
// module chunks = 7